import classNames from 'classnames';
import * as React from 'react';
import type { Theme } from '~/Utils/Theme';
import { themeDefaultValues } from '~/Utils/Theme';
import styles from './PicturePlaceholder.module.css';
import type { PlaceholderVariant } from './PlaceholderVariant';

export interface PicturePlaceholderProps {
    variant?: PlaceholderVariant;
    className?: string;
    logoWrapperClassName?: string;
    theme?: Theme;
}

export const PicturePlaceholder: React.FC<React.PropsWithChildren<PicturePlaceholderProps>> = props => {
    const { className, logoWrapperClassName, theme = themeDefaultValues, variant = 'default' } = props;

    const { withRoundedCorners } = theme;

    return (
        <div
            className={classNames(
                styles[`Variant--${variant}`],
                withRoundedCorners && styles['Variant--rounded'],
                className
            )}
        >
            <div className={classNames(styles.LogoWrapper, logoWrapperClassName)}>
                <div className={styles.Logo} />
            </div>
        </div>
    );
};
